import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import ImageWithBasePath from "../../../../core/img/ImageWithBasePath";
import { all_routes } from "../../../../core/data/routes/all_routes";
import BreadCrumb from "../../common/breadcrumb/breadCrumb";
import { PAYPAL_CLIENT_ID } from "../../../../firebase";

const BookingPayment = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigate = useNavigate();
  const category = location.state?.category;
  const [selectedPayment, setSelectedPayment] = useState("paypal");
  const [message, setMessage] = useState("");

  if (!category) {
    return <p>Category data not found!</p>;
  }

  const handlePaymentSuccess = (details) => {
    console.log("✅ Payment Successful:", details);
    setMessage(`Success! Transaction completed by ${details.payer.name.given_name}.`);
    navigate(routes.bookingDone, { state: { category, payment: details } });
  };
  

  const handlePaymentError = (error) => {
    console.error("❌ Payment Error:", error);
    setMessage("Error: Payment failed. Please try again.");
  };


  return (
    <>
      <BreadCrumb title="Bookings" item1="Customer" item2="Payment" />
      <div className="page-wrapper"style={{
            backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ul className="step-register row">
                  <li className="activate col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/calendar-icon.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Appointment</h6>
                      <p style={{ color: '#fff' }}>Choose time & date for the service</p>
                    </div>
                  </li>
                  <li className="activate col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/choose-icon-3.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Waiting For Technician</h6>
                      <p style={{ color: '#fff' }}>Accept the technician for service</p>
                    </div>
                  </li>
                  <li className="active col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/wallet-icon.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Payment</h6>
                      <p style={{ color: '#fff' }}>Select Payment Gateway</p>
                    </div>
                  </li>
                  <li className="col-md-3">
                    <div className="multi-step-icon">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/book-done.svg"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="multi-step-info">
                      <h6 style={{ color: '#fff' }}>Done</h6>
                      <p style={{ color: '#fff' }}>Completion of Booking</p>
                    </div>
                  </li>
                </ul>

                <div className="row">
                  <div className="col-lg-6">
                    <h5 className="pay-title" style={{ color: '#fff' }}>Payment Methods</h5>
                    <div className="row g-3">
                      <div className="col-lg-6">

                      </div>
                    </div>

                    {selectedPayment === "paypal" && (
                      <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, currency: "USD" }}>
                        <PayPalButtons
                          style={{ layout: "vertical" }}
                          createOrder={(data, actions) => {
                            console.log("🛒 Creating PayPal Order...");
                            return actions.order
                              .create({
                                intent: "CAPTURE",
                                purchase_units: [
                                  {
                                    amount: {
                                      currency_code: "USD",
                                      value: "1.00", // 🔹 Set fixed amount of $1.00 for testing
                                    },
                                  },
                                ],
                              })
                              .then((orderID) => {
                                console.log("✅ Order Created:", orderID);
                                return orderID;
                              })
                              .catch((err) => {
                                handlePaymentError(err);
                                console.error("❌ Order Creation Error:", err);
                              });
                          }}
                          onApprove={(data, actions) => {
                            console.log("🛠 Processing Payment...");
                            return actions.order
                              .capture()
                              .then(handlePaymentSuccess)
                              .catch((err) => {
                                handlePaymentError(err);
                                console.error("❌ Payment Capture Error:", err);
                              });
                          }}
                          onError={handlePaymentError}
                        />
                      </PayPalScriptProvider>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <h5 className="pay-title" style={{ color: '#fff' }}>Booking Summary</h5>
                    <div className="summary-box">
                      <div className="booking-info">
                        <div className="service-book">
                          <div className="service-book-img">
                            <img
                              src={category.category_view_icon || "placeholder-image-path.jpg"}
                              alt="img"
                            />
                          </div>
                          <div className="serv-profile">
                            <span className="badge badge-soft-primary">
                              {category.main_type}
                            </span>
                            <h2>{category.title}</h2>
                            <ul>
                              <li className="serv-pro">
                                <ImageWithBasePath
                                  src="assets/img/profiles/avatar-01.jpg"
                                  alt="img"
                                />
                              </li>
                              <li className="serv-review">
                                <i className="fa-solid fa-star" /> <span>4.9 </span>(255 reviews)
                              </li>
                              <li className="service-map">
                                <i className="feather icon-map-pin" /> Ganwalpola, Sri Lanka
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="booking-summary">
                        <ul className="booking-date">
                          <li>Date <span>07/01/2025</span></li>
                          <li>Time <span>12:30 PM - 01:00 PM</span></li>
                          <li>Service Provider <span>Raskhan Mohamed</span></li>
                        </ul>
                        <ul className="booking-date">
                          <li>Subtotal <span>₹ 150.00</span></li>
                          <li>Coupon Discount <span>₹ 5.00</span></li>
                          <li>Service Charges <span>₹ 3.00</span></li>
                        </ul>
                        <div className="booking-total">
                          <ul className="booking-total-list">
                            <li>
                              <span>Total</span>
                              <span className="total-cost">₹ {category.price}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="save-offer">
                        <p><i className="fa-solid fa-circle-check" /> Your total saving on this order ₹5.00</p>
                      </div>
                      <div className="booking-pay">
                        <Link to={routes.bookingDone} className="btn btn-dark me-3 w-100">
                          Proceed to Pay ₹ {category.price}
                        </Link>
                        {/* <Link to="#" className="btn btn-light">Skip</Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </div> 
          </div> 
        </div>
      </div>
    </>
  );
};

export default BookingPayment;
